function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useEffect, useRef } from 'react';
import throttle from '../../utils/throttle';
import styles from './SnackBar.module.scss';
import cs from 'classnames';
export var SnackBarContext = createContext('large');
export default function SnackBar(_ref) {
  var size = _ref.size,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'fixed' : _ref$position,
    className = _ref.className,
    children = _ref.children;
  var ref = useRef(null);
  useEffect(function () {
    if (position !== 'fixed') {
      return;
    }
    var scrollHandler = throttle(function () {
      try {
        var footer = document.querySelector('#wm-footer');
        if (footer && ref.current) {
          var rect = footer.getBoundingClientRect();
          var bottom = window.innerHeight - rect.top;
          ref.current.style.bottom = "".concat(Math.max(0, bottom), "px");
        }
      } catch (err) {
        // sorry no footer for you
      }
    }, 50);
    scrollHandler();

    // Click in case accordian
    window.addEventListener('click', scrollHandler);
    window.addEventListener('resize', scrollHandler);
    window.addEventListener('scroll', scrollHandler);
    return function () {
      window.removeEventListener('click', scrollHandler);
      window.removeEventListener('resize', scrollHandler);
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [position]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cs(styles.bar, styles["bar--".concat(size)], styles[position], _defineProperty({}, String(className), className))
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles.container, styles["container--".concat(size)], styles["container--".concat(position)])
  }, /*#__PURE__*/React.createElement(SnackBarContext.Provider, {
    value: size
  }, children)));
}